var React = require('react');

function KeyInline (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t\t.st0 {\n\t\t\tfill: currentColor;\n\t\t}\n\t"),React.createElement("g",{"key":1},React.createElement("path",{"className":"st0","d":"M10.5,27.7c0,1.2-1,2.2-2.2,2.2c-1.2,0-2.2-1-2.2-2.2c0-1.2,1-2.2,2.2-2.2C9.5,25.4,10.5,26.4,10.5,27.7z\n\t\t M35.1,0h-4.5c-0.2,0-0.4,0.1-0.5,0.2L15.9,14.5C10.9,12.2,5.1,13.8,2,18.3c-3.1,4.5-2.6,10.5,1.3,14.3c3.8,3.8,9.9,4.4,14.3,1.3\n\t\tc4.5-3.1,6.1-8.9,3.8-13.9l3.5-3.5l2.9,1c0.5,0.2,1,0.1,1.4-0.3c0.4-0.3,0.6-0.9,0.5-1.4l-0.5-3.6l1.1-1.1l2.2,1\n\t\tc0.5,0.2,1.2,0.2,1.6-0.2c0.4-0.4,0.6-1,0.5-1.5l-0.8-2.7l1.9-1.9c0.1-0.1,0.2-0.3,0.2-0.5V0.7C35.9,0.3,35.6,0,35.1,0z"}))]);
}

KeyInline.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 35.9 35.9","style":{"enableBackground":"new 0 0 35.9 35.9"},"xmlSpace":"preserve"};

module.exports = KeyInline;

KeyInline.default = KeyInline;
